module.exports = __webpack_public_path__ + "img/icons8-sedan.9c331e47.svg";